import {IFilter} from "../../../../domain/occasions/filters/IFilter";


export class RangeFilter implements IFilter<number>{

    protected min:number;
    protected max:number;

    constructor() {
        this.min = 0;
        this.max = Number.MAX_VALUE;
    }

    public IsValid(value:number): boolean {
        if(value == null){
            return true;
        }
        return this.min < value && value < this.max
    }

    public SetMin(price:number){
        this.min = price;
    }

    public SetMax(price:number){
        this.max = price;
    }
}


// WEBPACK FOOTER //
// C:/Users/Benoit/WebstormProjects/schiltz/client/src/app/infrastructure/occasions/filters/abstract/RangeFilter.ts